import {Slider} from "@/components/ui/slider.tsx";

export default function LightValueSlider({label, value, min, max, step, format, onPreview, onCommit,
    compact = false, disabled = false}: {
    label: string;
    value: number;
    min: number;
    max: number;
    step: number;
    format: (value: number) => string;
    onPreview: (value: number) => void;
    onCommit: (value: number) => void;
    compact?: boolean;
    disabled?: boolean;
}) {
    return <div className={compact ? "space-y-1 text-xs" : "space-y-2 text-sm"}>
        <div className="flex items-center justify-between"><span>{label}</span><span>{format(value)}</span></div>
        <Slider aria-label={label} value={[value]} min={min} max={max} step={step} disabled={disabled}
            onValueChange={([next]) => onPreview(next)}
            onValueCommit={([next]) => onCommit(next)}/>
    </div>;
}
